"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSkyboxCubeTexture = void 0;
var realmforge_common_1 = require("realmforge-common");
var realms_three_1 = __importDefault(require("realms-three"));
/*
 * Creates the skybox cube texture
 */
var createSkyboxCubeTexture = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var skyboxTexture, texturesData, images, missingTextures;
    var skybox = _b.skybox, getTexture = _b.getTexture;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (skybox.type !== realmforge_common_1.SkyboxType.Cube) {
                    throw new Error("Skybox is not a cube type");
                }
                skyboxTexture = new realms_three_1.default.CubeTexture();
                return [4 /*yield*/, Promise.all([
                        getTexture(skybox.rightAssetId).then(function (t) { return ({
                            texture: t,
                            id: skybox.rightAssetId,
                        }); }),
                        getTexture(skybox.leftAssetId).then(function (t) { return ({
                            texture: t,
                            id: skybox.leftAssetId,
                        }); }),
                        getTexture(skybox.topAssetId).then(function (t) { return ({
                            texture: t,
                            id: skybox.topAssetId,
                        }); }),
                        getTexture(skybox.bottomAssetId).then(function (t) { return ({
                            texture: t,
                            id: skybox.bottomAssetId,
                        }); }),
                        getTexture(skybox.frontAssetId).then(function (t) { return ({
                            texture: t,
                            id: skybox.frontAssetId,
                        }); }),
                        getTexture(skybox.backAssetId).then(function (t) { return ({
                            texture: t,
                            id: skybox.backAssetId,
                        }); }),
                    ])];
            case 1:
                texturesData = _c.sent();
                images = texturesData.map(function (t) {
                    var _a;
                    return (_a = t.texture) === null || _a === void 0 ? void 0 : _a.image;
                });
                missingTextures = texturesData.filter(function (data) { return !data.texture; });
                if (missingTextures.length > 0) {
                    console.warn("Missing textures ".concat(missingTextures
                        .map(function (data) { return "\"".concat(data.id, "\""); })
                        .join(",")));
                    return [2 /*return*/, skyboxTexture];
                }
                skyboxTexture.images = images;
                skyboxTexture.needsUpdate = true;
                return [2 /*return*/, skyboxTexture];
        }
    });
}); };
exports.createSkyboxCubeTexture = createSkyboxCubeTexture;
